import React, { useEffect, useState, useRef } from "react";
import { Helmet } from "react-helmet-async";
import {
   Volume2,
   VolumeOff,
  Printer,
  Bookmark,
  Share2 ,
  Home
} from "lucide-react";
import { Eye, Heart } from "lucide-react";
import bannerImg from "../assets/images/storynewbanner.png";
import { Mousewheel } from "swiper/modules";
import "swiper/css";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css/mousewheel";
import omimage from '../assets/images/omimage.png';
import storiesimg from '../assets/images/storiesimg.jpg';
import defaultimg from '../assets/images/omsaga_default.jpg';
import new_defaultimg from '../assets/images/new_omsaga_default.png';

import { apiUrl, assetsUrl } from "../config/Config";
import axios from "axios";
import Swal from 'sweetalert2';
import { useNavigate } from "react-router-dom";
import { Autoplay } from "swiper/modules";
import { useSelector } from "react-redux";

const Stories = () => {
    const [allstories, setallstories] = useState([]);
    let navigate = useNavigate();
    const customerdata = useSelector((store) => store.userReducer.customerdata);
    const audioRef = useRef(null);
    const [playing, setPlaying] = useState(false);

    const handleReadStory = (slug) => {
      if (customerdata?.token) {
        navigate("/story/" + slug);
        return;
      }

      Swal.fire({
        title: "Registration Required",
        text: "Please register or log in to read the full story.",
        icon: "info",
        iconColor: "#d65300",
        confirmButtonText: "OK",
        confirmButtonColor: "#d65300",
        allowOutsideClick: false,
      }).then((result) => {
        if (result.isConfirmed) {
          navigate("/register");
        }
      });
    };

    const handleplayaudio = (name) => {
      // var url = '/storage/uploads/audio/'+name;
      var url = assetsUrl + "/audio/" + name
      console.log('url >>', url)
      if (!audioRef.current) {
        audioRef.current = new Audio(url);
      }
      audioRef.current.play();
      setPlaying(true);
    }

    const handleStop = () => {
      if (audioRef.current) {
        audioRef.current.pause();
        audioRef.current.currentTime = 0;
        setPlaying(false);
      }
    };

    const fetchallstories = async () => {
        // setshowloding(true);
        const headers = {
            headers: {
              "Content-Type": "application/json"
            },
          };
          let resp = await axios
          .get(apiUrl + "getallstories", headers)
          .then((res) => {
            if (res.data.status == "success") {
                var prevdata = res?.data?.data;
                if(prevdata?.length > 0) {
                  setallstories(prevdata);
                } else {
                  setallstories([]);
                }
            } else {
              setallstories([]);
            }
         }).catch((err) => {
          console.log('err >>', err);
         })

      }

    useEffect(() => {
        fetchallstories();
    }, [])
    return (
<>
<Helmet>
        {/* Meta Title */}
        <title>Spiritual Stories Collection</title>

        {/* Meta Description */}
        <meta
          name="description"
          content="Explore a curated collection of inspirational spiritual stories and divine tales. Read real experiences of faith, and answered prayers."
        />

        {/* Primary Keywords */}
        <meta
          name="keywords"
          content="spiritual stories, spiritual tale, spiritual story telling platform"
        />

        {/* Canonical Tag */}
        <link rel="canonical" href="https://theomsaga.com/stories" />

        {/* Open Graph Tags */}
        <meta property="og:title" content="Spiritual Stories Collection" />
        <meta
          property="og:description"
          content="Explore a curated collection of inspirational spiritual stories and divine tales. Read real experiences of faith, and answered prayers."
        />
        <meta property="og:url" content="https://theomsaga.com/stories" />
        <meta
          property="og:image"
          content="https://theomsaga.com/assets/images/storynewbanner.webp"
        />

        {/* Schema Markup */}
        <script type="application/ld+json">
          {`
          {
            "@context": "https://schema.org",
            "@type": "CollectionPage",
            "@id": "https://theomsaga.com/stories#collectionpage",
            "name": "Spiritual Stories Collection",
            "url": "https://theomsaga.com/stories",
            "description": "A curated collection of inspirational spiritual stories, real-life faith experiences, and divine tales shared on TheOmSaga.",
               "sameAs": [
                  "https://www.instagram.com/theomsaga20?igsh=MWNnN3E0NGVleTltZw==",
                  "https://www.facebook.com/share/1B44vEtGc7/"
                ]
          }
          `}
        </script>
      </Helmet>

      <div>
        <section className="home-main-sec ">

        <img src={bannerImg} className="home-main-sec-bg" alt="Banner" />

        <div className="home-main-sec-overlay"></div>

        <div className="container home-main-sec-content">

          <h1 className="loop-title">
          
            Inspirational Spiritual Stories & Real-Life Experiences

          </h1>



        </div>

      </section>

            {allstories?.length > 0 ? (
//         <section className="home-stories-main-section">
//           <div className="container text-center">
//             <img src={omimage} alt="Logo" className="om-image-stories" loading="eager" decoding="async"/>
//             <span className="home-subhead">Stories</span>
//             <p className="home-heading">All Stories</p>
//             <div className="home-heading-divider"></div>

//             <div className="home-stories-mid-section">
//               <div className="row">
//               {allstories?.map((item, index) => {
//                 var reloadimg = "";
//                 if(item?.photos) {
//                   var imagesarr = JSON.parse(item?.photos);
//                   if(imagesarr?.length > 0) {
//                     reloadimg = imagesarr[0];
//                   }
//                 }
//                 return (
//                   <div className="col-12 col-md-6 col-lg-4 mb-4" key={index}>
//                     <div className="home-storiesgrid-box" data-aos="fade-up" data-aos-delay="300" data-aos-duration="500">
//                       <img className="home-stories-box-img" src={reloadimg ? assetsUrl + '/photos/'+reloadimg : storiesimg} alt="" />
//                       <div className="home-stories-box-content">
//                         <p className="home-stories-box-content-tittle">{item?.title}</p>
// <div className="home-page-meta-row">
//   <div className="home-page-meta-item">
//     <Heart size={16} className="home-page-like-icon" />
//     <span>{item?.likes || 0}</span>
//   </div>

//   <div className="home-page-meta-item">
//     <Eye size={16} className="home-page-view-icon" />
//     <span>{item?.views || 0}</span>
//   </div>
// </div>



//                         <div className="home-stories-box-content-footer">
                          
//                           <p className="home-stories-box-content-readmore" onClick={() => navigate('/story/'+item?.slug)}>
//                             Read More
//                           </p>

//                           {item?.audio ? (
//                             <>
//                               {playing ? (
//                                 <div onClick={() => handleStop(item?.audio)}>
//                                   <VolumeOff size={20} className="home-stories-box-audioicon"/>
//                                 </div>
//                               ) : (
//                                 <div onClick={() => handleplayaudio(item?.audio)}>
//                                   <Volume2 size={20} className="home-stories-box-audioicon"/>
//                                 </div>
//                               )}
//                             </>
//                           ) : null}

//                         </div>
//                       </div>
//                     </div>
//                   </div>
//                 );
//               })}
//               </div>
//             </div>
//           </div>
//         </section>
<section className="home-stories-main-section">
  <div className="container text-center">
    <img src={omimage} className="om-image-stories" />
    <span className="home-subhead">Stories</span>
    <p className="home-heading">Stories That Inspire</p>
    <div className="home-heading-divider"></div>

    <Swiper
              spaceBetween={20}
              grabCursor={true}
              modules={[Autoplay]}
              autoplay={{
                delay: 3000,
                disableOnInteraction: false,
                pauseOnMouseEnter: true,
              }}
              loop={true}
              style={{ paddingBottom: "20px" }}
              breakpoints={{
                0: {
                  slidesPerView: 1,   // mobile
                },
                768: {
                  slidesPerView: 5,   // tablet & desktop
                },
              }}
            >
      {allstories?.map((item, index) => {
        let reloadimg = "";
        if (item?.photos) {
          const arr = JSON.parse(item?.photos);
          if (arr?.length > 0) reloadimg = arr[0];
        }

        return (
          <SwiperSlide className="home-story-slide" key={index}>
            <div className="home-story-card">

              {/* BG Image */}
              <img
                src={
                  reloadimg
                    ? assetsUrl + "/photos/" + reloadimg
                    : new_defaultimg
                }
                className="home-story-card-img"
                alt=""
              />

              {/* Dark bottom fade */}
              <div className="home-story-overlay"></div>

              {/* Category */}
              {
                item?.audio ?
                null :
                 <div className="home-story-category">• Story</div>
              }
              

              {/* Content */}
              <div className="home-story-content">
                <p className="home-story-title">{item?.title}</p>

                <div className="home-meta-row">
                  <div className="home-meta-item">
                    <Heart size={14} />
                    <span>{item?.liked || 0}</span>
                  </div>

                  <div className="home-meta-item">
                    <Eye size={14} />
                    <span>{item?.view || 0}</span>
                  </div>
                </div>

                <p
                  className="home-story-readmore"
                  onClick={() => handleReadStory(item?.slug)}
                >
                  Read More
                </p>
              </div>

              {/* Audio Icon */}
              {item?.audio && (
                <div className="home-story-audio">
                  {playing ? (
                    <VolumeOff size={20} onClick={() => handleStop(item?.audio)} />
                  ) : (
                    <Volume2 size={20} onClick={() => handleplayaudio(item?.audio)} />
                  )}
                </div>
              )}
            </div>
          </SwiperSlide>
        );
      })}
    </Swiper>
  </div>
</section>



      ) : null}
      
      </div>
</>

 
    );
}
export default Stories
